<template>
  <div class="ncl">
    <detail-header v-show="chaerShow" ></detail-header>
    <detail-card @postDate="getDate" @year="getYear" v-show="chaerShow"></detail-card>
    <detail-table :dateData="dateData" :year="year"  @chaerShowClick="chaerShowClick" v-if="pageCode=='01'"></detail-table>
    <per-table :dateData="dateData" :year="year"  @chaerShowClick="chaerShowClick" v-else-if="pageCode==='02'"></per-table>
    <bank-table :dateData="dateData" :year="year"  @chaerShowClick="chaerShowClick" v-else-if="pageCode==='03'"></bank-table>
    <ren-table :dateData="dateData" :year="year"  @chaerShowClick="chaerShowClick" v-else-if="pageCode==='05'"></ren-table>
    <team-table :dateData="dateData" :year="year"  @chaerShowClick="chaerShowClick" v-else-if="pageCode==='04'"></team-table>
<!--    <detail-product v-if="structureShow!=1"></detail-product>-->
<!--    <detail-structure v-if="structureShow!=1"></detail-structure>-->
    <smartbi-entirety-pie :chooseDateValue="chooseDateValue" v-show="chaerShow" ></smartbi-entirety-pie>
  </div>
</template>

<script>
import DetailHeader from './components/EntDetailHeader'
import DetailCard from './components/EntDetailCard'
import DetailTable from './components/EntTable'
import SmartbiEntiretyPie from './components/SmartbiEntiretyPie'
import PerTable from './components/PerTable.vue'
import BankTable from './components/BankTable.vue'
import RenTable from './components/RenTable.vue'
import TeamTable from './components/TeamdetailTable.vue'
import TeamRateTable from './components/TeamRateTable.vue'
import { getUrlKey, resetUserSessionStorage } from '@/utils/util'
export default {
  name: 'EntiretyHome',
  components: {
    DetailHeader,
    DetailCard,
    DetailTable,
    SmartbiEntiretyPie,
    PerTable,
    BankTable,
    RenTable,
    TeamTable,
    TeamRateTable
  },
  data () {
    return {
      structureShow: null,
      dateData: null,
      chooseDateValue: null,
      chaerShow: true,
      pageCode: null,
      tableFlag: null,
      year: null
    }
  },
  created () {
    this.$store.commit('ENTIRETY_SET_CHANNEL', this.$route.query.channelId)
    this.$store.commit('ENTIRETY_SET_CHANNEL_NAME', this.$route.query.channelName)
    this.$store.commit('ENTIRETY_SET_QUOTA', this.$route.query.indexId)
    this.$store.commit('ENTIRETY_SET_TIME', this.$route.query.time)
    this.$store.commit('ENTIRETY_SET_KIND', this.$route.query.kind)
    this.$store.commit('USER_SET_LEVEL', this.$route.query.level)
    this.$store.commit('USER_SET_ORG', this.$route.query.orgId)
    this.$store.commit('USER_SET_PAGE_CODE', this.$route.query.moduleId)
    this.$store.commit('USER_SET_AREA_FLAG', this.$route.query.areaFlag)
    this.$store.commit('ENTIRETY_SET_TYPE', this.$route.query.type)
    this.pageCode = this.$store.state.user.pageCode
  },
  methods: {
    getDate (data1, data2) {
      this.dateData = data1
      this.chooseDateValue = data1
    },
    getYear (val) {
      this.year = val
    },
    chaerShowClick (str) {
      this.chaerShow = str
    }
  },
  computed: {
    getTime () {
      return this.$store.state.entirety.time
    }
    // onRefresh () {
    //   setTimeout(() => {
    //     this.getHomeInfo()
    //     this.$toast('刷新成功')
    //     this.isLoading = false
    //   }, 500)
    // }
  },
  watch: {
    getTime () {
      this.$nextTick(() => {
        this.structureShow = this.$store.state.entirety.time
      })
    }
  },
  mounted () {
    // let getquocard = this.$store.state.entirety.quota
    // if (getquocard === 'A0104-1004' && this.$store.state.user.pageCode === '04') {
    //   this.tableFlag = 2
    // } else {
    //   this.tableFlag = 1
    // }
    window.onpageshow = function (event) {
      if (event.persisted) {
        console.log('浏览器缓存读取-整体类')
        // 处理登录用户信息
        // let queryToken = getUrlKey('token', window.location.href)
        // resetUserSessionStorage(queryToken)
         let queryTm = getUrlKey('tm', window.location.href)
        resetUserSessionStorage(queryTm)
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/entirety/EntiretyDetail.vue